<script>
    import Toggle from "../Toggle.svelte";
    import CardValue from "./CardValue.svelte";
    import Button from "../Button.svelte";

    export let engineId = "";
    export let gameId = "";
    export let clientId = "";
    export let mechanicId = "";
    export let mathId = "";
    export let enabled;
    export let instanceTemplate = [{"label": "Bet Limits", "type": "betLimit"}, {"Default Bet": "betValue", "DependsOn": ""}, {}];
    export let instanceValues = {};
    export let imgSrc = "";

    let clicked;
</script>

<div class="outer-card">
    <div class="game-card">
        <div class="{clicked ? 'game-card__inner flip' : 'game-card__inner'}">
            <div class="game-card__front" on:click="{()=> {console.log('To true');clicked = true}}">
                <img class="game-card__image" src={imgSrc}/>
            </div>
            <div class="game-card__back">
                <CardValue label="EngineId" value={engineId}/>
                <CardValue label="MathId" value={mathId}/>
                <CardValue label="ClientId" value={clientId}/>
                <Button text="Back" onClickFunction="{()=>{console.log('To false');clicked = false}}"/>
            </div>
        </div>
    </div>
    <div class="game-card__front__information">
        <CardValue label="GameId" value={gameId}/>
        <Toggle enabled={enabled}/>
    </div>
</div>

<style>
    .outer-card {
        max-width: min(300px, 100% - 2rem);
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
    }

    .game-card {
        width: fit-content;
        border-radius: 8px;
        background: var(--background-color);
        perspective: 1000px;
    }

    .game-card__inner {
        position: relative;
        width: 100%;
        height: 100%;
        text-align: center;
        transition: transform 0.8s;
        transform-style: preserve-3d;
        border: 2px solid;
        border-radius: 8px;
    }

    /*.game-card:active .game-card__inner {*/
    /*    transform: rotateY(180deg);*/
    /*}*/

    .flip {
        transform: rotateY(180deg);
    }

    .game-card__front, .game-card__back {
        width: 100%;
        height: 100%;
        backface-visibility: hidden;
        background-color: var(--dark-background);
        padding: 4px;
        border-radius: 8px;
    }

    .game-card__back {
        position: absolute;
        top: 0;
        left: 0;
        border-radius: 8px;
        color: #232323;
    }

    /* Style the back side */
    .game-card__back {
        transform: rotateY(180deg);
    }

    .game-card__image {
        width: 100%;
        aspect-ratio: 1;
        background-size: contain;
        border-radius: 8px;
    }

    .game-card__front__information {
        width: 100%;
        margin-top: 8px;
        border: 2px solid;
        padding: 8px;
        border-radius: 8px;
        background: var(--background-color);
    }


</style>
